<template>
  <div>
    <h6 class="title is-6 has-text-left has-text-grey">
      Match Results
    </h6>
    <div class="document">
      <es-loader
        v-if="loading"
        style="margin: 3rem"
      />
      <es-exception
        v-else-if="loadingError && !personNotFoundError && !perFoundButDiffPerType"
        exceptionMessage="There was an issue. Please try again or contact your administrator."
        class="exception-class"
      />
      <es-exception
        v-else-if="loadingError && personNotFoundError"
        exceptionMessage="No results were found."
        class="exception-class"
      />
      <es-exception
        v-else-if="loadingError && perFoundButDiffPerType"
        exceptionMessage="Sorry, you are not authorized to access this content.."
        class="exception-class"
      />
      <es-exception
        v-else-if="!student.stateStudentId"
        exceptionMessage="Records must be submitted to view results."
        class="exception-class"
      />
      <manual-match
        v-else
        :loadingErrorParent="loadingError"
        :personTypeAccess="personTypeAccess"
        :perFoundButDiffPerType="perFoundButDiffPerType"
        :student="student"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import ManualMatch from '@/views/DirectMatch/MatchOptions/ManualMatch.vue';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    EsException,
    EsLoader,
    ManualMatch,
  },
  props: {
    // value coming from router to help return the match type id for the give matchTypeCode.
    matchTypeCode: {
      type: String,
    },
    studentId: {
      type: String,
    },
    userPersonTypesCodes: {
      type: Array,
    },
  },
  data() {
    return {
      errors: null,
      loading: false,
      loadingError: false,
      personNotFoundError: false,
      perFoundButDiffPerType: false,
      student: {},
    };
  },
  watch: {
    studentId() {
      if (this.studentId) { // new studentId
        this.getStudent();
      } else { // reset results
        this.student = {};
        this.loadingError = false;
      }
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    contextMode() {
      const identityControl = this.properties['IDENTITY_CONTROL-LIFETIME_IDS'];
      return JSON.parse(identityControl.toString().toLowerCase()) === false;
    },
    personTypeAccess() {
      return this.userPersonTypesCodes.includes(this.student.personType);
    },
  },
  methods: {
    reset() {
      this.errors = null;
      this.loading = true;
      this.loadingError = false;
      this.personNotFoundError = false;
      this.perFoundButDiffPerType = false;
      this.student = {};
    },
    async getStudent() {
      try {
        // TODO: emit to manula form that data is loading
        // this.$root.$emit('dmMatchOptionsLoading', true); // Match Results loader
        this.reset();

        const res = await axios.get(`person/${this.studentId}`);
        this.student = res.data;
        if (!this.personTypeAccess && this.contextMode) {
          this.loadingError = true;
          this.perFoundButDiffPerType = true;
        }
      } catch (error) {
        this.loadingError = true;
        if (error.response.status === 404) {
          this.errors = [error.response.data.message];
          if (this.errors.includes('Person not found')) {
            this.personNotFoundError = true;
          }
        } else {
          this.showNotification('danger', ['There was an issue. Please try again or contact your administrator.']);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  h6
    margin-bottom: 1rem !important
  .exception-class
    padding: 3rem
    margin: 0
</style>
